import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import { Router } from '@angular/router';
import { HeaderBarButtonComponent } from '@components/header-bar/button/header-button.component';
import { HOME_PAGE } from 'src/app/app.routes';

@Component({
  selector: 'tmn-header-bar',
  standalone: true,
  templateUrl: './header-bar.component.html',
  styleUrl: './header-bar.component.scss',
  imports: [HeaderBarButtonComponent],
})
export class HeaderBarComponent {
  @Input() teamsCampaignVisible: boolean = false;
  @Input() thresholdsVisible: boolean = false;
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  private readonly router: Router = inject(Router);

  public goToHome(): void {
    this.router.navigate([`/${HOME_PAGE}`]);
  }
}
